import '../../sass/template-parts/image-carousel.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $imageCarousels = document.querySelectorAll('.image-carousel');

    if (!$imageCarousels) return;

    $imageCarousels.forEach($imageCarousel => {
        const $carousel = $imageCarousel.querySelector('.image-carousel__carousel');
        const $carouselPrev = $imageCarousel.querySelector('.image-carousel__carousel-prev');
        const $carouselNext = $imageCarousel.querySelector('.image-carousel__carousel-next');

        const initCarousel = () => {
            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                slidesPerView: 'auto',
                navigation: {
                    nextEl: $carouselNext ?? null,
                    prevEl: $carouselPrev ?? null,
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                speed: noMotionPreference.matches ? 300 : 0,
            });

            carousel.on('afterInit', () => {
                this.slideTo(0);
            });

        };

        initCarousel();
    });
})();
